import api from '@/config/api'
import type { ApiResponse } from '@/shared/types/api'
import type { DatabaseStats, FlywayMigration, CleanupResult } from '../types/database-admin'

export async function getDatabaseStats(): Promise<DatabaseStats> {
  const response = await api.get<ApiResponse<DatabaseStats>>('/api/admin/database/stats')
  return response.data.data
}

export async function getFlywayMigrations(): Promise<FlywayMigration[]> {
  const response = await api.get<ApiResponse<FlywayMigration[]>>('/api/admin/database/migrations')
  return response.data.data
}

export async function cleanPasswordTokens(): Promise<CleanupResult> {
  const response = await api.delete<ApiResponse<CleanupResult>>('/api/admin/database/cleanup/password-tokens')
  return response.data.data
}

export async function cleanErrorLogs(daysThreshold: number = 30): Promise<CleanupResult> {
  const params = new URLSearchParams()
  params.set('daysThreshold', String(daysThreshold))
  const response = await api.delete<ApiResponse<CleanupResult>>(
    `/api/admin/database/cleanup/error-logs?${params}`
  )
  return response.data.data
}
